import { IonContent, IonFooter, IonSplitPane } from '@ionic/react';
import React from 'react';
import Menu from '../../components/Menu';
import MobileNavBar from '../../components/MobileNavBar';
import { useBreakpoint, useIsMobile } from '../../utils/helpers/platformHelpers';
import './AppLayout.scss';
import { AppRoutes } from './AppRoutes';
import { CreateControllerFormModal } from '../../components/controllers/CreateControllerFormModal';

const AppLayout: React.FC = () => {
  const isMobile = useIsMobile();
  const isLargeBreakpoint = useBreakpoint('lg');

  return (
    <IonSplitPane contentId="main" when={isLargeBreakpoint}>
      <Menu />
      <div id="main">
        <IonContent scrollX={false} scrollY={false}>
          <AppRoutes />
        </IonContent>
        {isMobile && (
          <IonFooter className="footer-container">
            <MobileNavBar />
          </IonFooter>
        )}

        <CreateControllerFormModal />
      </div>
    </IonSplitPane>
  );
};

export default AppLayout;
